export const trendingPeriodFormatter = (period) => {
  if (period === 'hour1') return '1 hour';
  if (period === 'day1') return '1 day';
  if (period === 'minutes15') return '15 mins';
};

export const trendingBarClassesArgumentCheck = (trendingClasses) => {
  if (Array.isArray(trendingClasses) && trendingClasses.length > 0) {
    return trendingClasses.map((asset) => asset.id).join(',');
  }
  if (trendingClasses.length <= 0) return '';
  return 'all';
};

export const checkAssets = (trendingClasses, id) => trendingClasses.some((item) => item.id === id);
